/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ParticipationUserCustomFieldFilter = {
    /**
     * Customer-created field label as it appears on the participation tabs.
     */
    fieldName: string;
    operator: ParticipationUserCustomFieldFilter.operator;
    value: string;
};

export namespace ParticipationUserCustomFieldFilter {

    export enum operator {
        EQUAL = 'EQUAL',
        NOT_EQUAL = 'NOT_EQUAL',
    }


}

